module.exports = __webpack_public_path__ + "static/fonts/NotoSansCJKkr-Bold.ff5afcd.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/views/couponsys/assets/fonts/NotoSansCJKkr-Bold.woff2
// module id = v/lJ
// module chunks = 0